import {
    HANDLE_CHEAT,
    MARK_GENERAL,
    MARK_SPEAKING,
    MARK_TRIAL,
    PENDING,
    SUCCESS,
    MARK_ENTRANCE_SPEAKING,
    MARK_ENTRANCE_GENERAL
} from "@/view/pages/marking-exam/model/taskPersonal";
import moment from "moment/moment";

export class TaskModel {
    constructor(task) {
        this.id = task.id;
        this.type = +task.type;
        this.typeTask = this.getLabelType(+task.type);
        this.bgType = this.getBgType(+task.type);
        this.processing = task.handler
        this.status = this.getLabelStatus(+task.status, task.is_fraud);
        this.bgStatus = this.getBgStatus(+task.status, task.is_fraud);
        this.startDate = this.formatDateTime(task.start_date);
        this.endDate = this.formatDateTime(task.end_date);
        this.classroom = task?.classroom?.name ?? ''
        this.course = task?.course?.name ?? ''
        this.handler = task?.admin_profile?.name ?? '';
        this.createdAt = this.formatDateTime(task.created_at);
        this.markingExamRetakeId = task.marking_exam_retake_id
        this.selected = false;
        this.classroomId = task.classroom_id
        this.assignedAt = this.formatDateTime(task.assigned_at)
        this.deadline = this.formatDateTime(task.deadline)
        this.examTypelabel = task?.exam_type_label
        this.gradingHander = task?.grading_handler??null;
    }
    getLabelType(type) {
        switch (type) {
            case MARK_SPEAKING:
                return 'Chấm thi Speaking'
            case MARK_GENERAL:
                return 'Chấm thi General'
            case MARK_TRIAL:
                return 'Chấm thi giữa khoá'
            case MARK_ENTRANCE_SPEAKING:
                return 'Chấm thi đầu khóa Speaking'
            case MARK_ENTRANCE_GENERAL:
                return 'Chấm thi đầu khóa General'
            default:
                return ''
        }
    }
    getBgType(type) {
        switch (type) {
            case MARK_SPEAKING:
                return 'bg-blue-500'
            case MARK_GENERAL:
                return 'bg-yellow-500'
            case MARK_TRIAL:
                return 'bg-success'
            case MARK_ENTRANCE_SPEAKING:
                return 'bg-entrance-exam-speaking'
            case MARK_ENTRANCE_GENERAL:
                return 'bg-entrance-exam-general'
        }
    }
    // status=HANDLE_CHEAT gánh cả 2 mức: is_fraud=1 đã xác nhận (điểm bị 0),
    // is_fraud=0 mới nghi ngờ (giữ nguyên điểm chờ admin xử lý).
    getLabelStatus(status, isFraud) {
        switch (status) {
            case PENDING:
                return 'Cần làm';
            case SUCCESS:
                return 'Hoàn thành';
            case HANDLE_CHEAT:
                return isFraud ? 'Đã xử lý gian lận' : 'Nghi ngờ gian lận';
        }
    }
    getBgStatus(status, isFraud) {
        switch (status) {
            case PENDING:
                return 'bg-yellow-500';
            case SUCCESS:
                return 'bg-success';
            case HANDLE_CHEAT:
                return isFraud ? 'bg-red-500' : 'bg-orange-500';
        }
    }
    formatDateTime(value) {
        if (!value) return ''
        return moment(value).format('DD-MM-YYYY HH:mm:ss')
    }
}

export class TaskDetailModel {
    constructor(task) {
        this.taskCode = task?.id
        this.type = +task.type
        this.showMark = +task.status === 0
        this.showHandleCheating = +task.status === 2
        this.name = this.getLabelType(+task.type)
        this.statusLabel = this.getLabelStatus(+task.status)
        this.bgStatus = this.getBgStatus(+task.status)
        this.isEntrance = [MARK_ENTRANCE_SPEAKING, MARK_ENTRANCE_GENERAL].includes(+task.type)
        this.typeTask = this.isEntrance ? 'Thi đầu khóa' : 'Chấm thi'
        this.typeTest = 'Online'
        this.startDate = this.formatDateTime(task?.start_date)
        this.endDate = this.formatDateTime(task?.end_date)
        this.center = task?.center_name ?? ''
        this.base = task?.branch_name ?? ''
        this.customerName = task?.user_name ?? ''
        this.phone = task?.user_phone ?? ''
        this.point = task?.skill?.score ?? {}
        this.resultTest = task?.skill?.score_data
        this.resultType = this.getLabelResultType(task?.skill?.skill)
    }
    getLabelType(type) {
        switch (type) {
            case MARK_SPEAKING:
                return 'Chấm thi Speaking'
            case MARK_GENERAL:
                return 'Chấm thi General'
            case MARK_ENTRANCE_SPEAKING:
                return 'Chấm thi đầu khóa Speaking'
            case MARK_ENTRANCE_GENERAL:
                return 'Chấm thi đầu khóa General'
            default:
                return ''
        }
    }
    getLabelStatus(status) {
        switch (status) {
            case PENDING:
                return 'Cần làm';
            case SUCCESS:
                return 'Hoàn thành';
            case HANDLE_CHEAT:
                return 'Xử lý gian lận';
        }
    }
    getBgStatus(status) {
        switch (status) {
            case PENDING:
                return 'bg-yellow-500';
            case SUCCESS:
                return 'bg-success';
            case HANDLE_CHEAT:
                return 'bg-red-500';
        }
    }
    formatDateTime(value) {
        if (!value) return ''
        return moment(value).format('DD-MM-YYYY HH:mm:ss')
    }
    getLabelResultType(type) {
        switch (type) {
            case 3:
                return 'Writing'
            case 4:
                return 'Speaking'
            default:
                return ''
        }
    }
}